// Form validation for Roles form
import { multiselectValidator, plaintextValidator } from '../fields';

const config = {};

export default {
  name: plaintextValidator({ mandatory: true }),
  description: plaintextValidator(config),
  users: multiselectValidator(config)
};
